import { REGISTRATION_COMPLETED, RETURN_HOME, dispatchToMobile, isHybridApp, isInApp } from "./mobileCommunication"

const getCookieLoggedName = () => {
  switch (process.env.REACT_APP_NODE_ENV) {
    case 'pull_request':
      return 'staging_shared_cookie'
    case 'development':
      return 'development_shared_cookie'
    case 'staging':
      return 'staging_shared_cookie'
    case 'production':
      return 'shared_cookie'
    default:
      return 'staging_shared_cookie'
  }
}

const getToken = () => {
  const r = document.cookie.match(`\\b${getCookieLoggedName()}=([^;]*)\\b`)
  return r ? r[1] : undefined
}

const redirectToLogin = () => {
  sessionStorage.clear()
  window.location.assign(process.env.REACT_APP_PLURALL_LOGIN_URL)
}

const redirectToOnboardingSelection = () => {
  sessionStorage.clear()
  if (isHybridApp) {
    dispatchToMobile(RETURN_HOME)
    return
  }
  window.location.assign(
    `${process.env.REACT_APP_PLURALL_LOGIN_URL}/login/informacoes`,
  )
}

const redirectToHome = () => {
  sessionStorage.clear()
  if (isInApp()) {
    dispatchToMobile(REGISTRATION_COMPLETED)
    return
  }
  window.location.assign(process.env.REACT_APP_PLURALL_HOME_URL)
}

const redirectToSignIn = (userStore) => {
  sessionStorage.clear()
  if (isInApp()) {
    dispatchToMobile(REGISTRATION_COMPLETED)
    return
  }
  const { email, password, username } = userStore
  sessionStorage.setItem('password', password)
  sessionStorage.setItem('login', email || username)
  window.location.assign('/cadastro/sign-in')
}

const clearToken = () => {
  const sharedCookieName = getCookieLoggedName()

  document.cookie = `${sharedCookieName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.plurall.net`
}

function Logout() {
  clearToken()
  sessionStorage.clear()
  window.location.assign(`${process.env.REACT_APP_PLURALL_LOGIN_URL}/logout`)
}

const setToken = (token) => {
  const sharedCookieName = getCookieLoggedName()
  document.cookie = `${sharedCookieName}=${token};path=/;domain=.plurall.net`
}

export {
  getToken,
  redirectToHome,
  redirectToLogin,
  redirectToOnboardingSelection,
  redirectToSignIn,
  setToken,
  clearToken,
  Logout,
  getCookieLoggedName,
}
